module.exports = __webpack_public_path__ + "img/app_alarm.9121fcf3.svg";